import { type ValidChartingQualifications } from "@src/appV2/Charting/api/schema";
import { WORKPLACE_TYPES } from "@src/appV2/constants/workplaceTypes";

export const PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 100;
export const VALID_CHARTING_QUALIFICATIONS: ValidChartingQualifications[] = [
  "Certified Medication Aide",
  "CNA",
  "LVN",
  "RN",
];
export const MIN_START_DATE = "2025-01-01";
export const USER_ENGINEER_NAME = "Clipboard Automatic Verification";
export const REVIEW_DURATION_IN_HOURS = 72;
export const DEFAULT_RECALL_GRACE_PERIOD_DURATION_IN_HOURS = 72;

export const CHARTING_COMPLETION_REPORT_CACHE_SETTINGS = {
  // Cache for 10 minutes since recall counts don't change frequently
  staleTime: 10 * 60 * 1000,
  // Keep in cache for 5 minutes after component unmounts
  cacheTime: 5 * 60 * 1000,
  // Background refetch every 15 minutes to keep data fresh
  refetchInterval: 15 * 60 * 1000,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchIntervalInBackground: false,
};

export type RecallStatus = "-" | "Recall in Progress" | "Charting Verified";

export type ChartingStatus = "Not Started" | "Partially Complete" | "Complete" | "-";

export const CHARTING_INCOMPATIBLE_WORKPLACE_TYPES: string[] = [
  WORKPLACE_TYPES.CHILD_CARE_CENTER,
  WORKPLACE_TYPES.HOME_HEALTHCARE,
  WORKPLACE_TYPES.DENTAL_CLINIC,
  WORKPLACE_TYPES.SCHOOL,
];
